"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const mobx_react_1 = require("mobx-react");
const SequenceDisplay = (0, mobx_react_1.observer)(function ({ chunks, start, color, strand = 1, coordStart = start, model, }) {
    const { charactersPerRow, showCoordinates } = model;
    return chunks.map((chunk, idx) => {
        var _a;
        const f = coordStart - (start % charactersPerRow);
        const prefix = (idx == 0 && start % charactersPerRow == 0) || idx > 0
            ? `${f + idx * strand * charactersPerRow}`.padStart(4) + '   '
            : '';
        const postfix = idx === chunks.length - 1 &&
            (((_a = chunks.at(-1)) === null || _a === void 0 ? void 0 : _a.replaceAll(' ', '').length) || 0) +
                (idx === 0 ? start % charactersPerRow : 0) !==
                charactersPerRow
            ? null
            : showCoordinates
                ? ' \n'
                : '';
        return (react_1.default.createElement(react_1.default.Fragment, { key: `${chunk}-${idx}` },
            showCoordinates ? prefix : null,
            react_1.default.createElement("span", { style: { background: color } }, chunk),
            postfix));
    });
});
exports.default = SequenceDisplay;
